var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:'text-' + _vm.statusColor,attrs:{"close":_vm.close,"color":'bg-light-' + _vm.statusColor},on:{"click:close":_vm.emitClickClose}},[(_vm.marker)?_c('v-avatar',{staticClass:"mr-3",attrs:{"left":""}},[_c('v-img',{attrs:{"src":'/media/marker/Marker_' + _vm.statusColor + '.png'}})],1):_vm._e(),_vm._v(" "+_vm._s(_vm.statusName)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }